module.exports = __webpack_public_path__ + "img/coming-soon-M.a005d762.jpg";